import React from 'react';
import { MapPin } from 'lucide-react';
export function LocationsHero() {
  return <section className="relative py-16 md:py-24 overflow-hidden" data-id="element-639">
      {/* Background Map Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-640">
        <img src="https://cdn.magicpatterns.com/uploads/qyhDhLHoGw6ES81LFhTk6u/image.png" alt="Michigan Map" className="w-full h-full object-cover" data-id="element-641" />
        {/* White overlay for readability */}
        <div className="absolute inset-0 bg-white/80" data-id="element-642"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-643">
        <div className="inline-flex items-center justify-center p-3 bg-white rounded-full mb-6 shadow-sm" data-id="element-644">
          <MapPin className="h-6 w-6 text-[#dc2626]" data-id="element-645" />
        </div>

        <h1 className="text-4xl md:text-5xl font-bold text-[#1a2332] mb-6" data-id="element-646">
          Our Locations
        </h1>

        <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-647">
          Proudly serving families across Michigan with professional martial
          arts training in multiple convenient locations.
        </p>
      </div>
    </section>;
}